import { Footer } from '@/components/Footer';
import { Future } from '@/modules/token-sale';
import {
  CommunitySection,
  Growing,
  Introduction,
  Possibilities,
  Stats,
} from '@/modules/xbg';
import { NextGenGamingNoTitle } from '@/modules/token-sale/components/NextGenGaming/NextGenGamingNoTitle';

export default function Xbg() {
  return (
    <div className="xbg">
      <Introduction />
      <Possibilities />
      <Growing />
      <Stats />
      <CommunitySection />
      <NextGenGamingNoTitle />

      <Footer />
    </div>
  );
}
